export default {
  annualRecurringIterationBenefit1: {
    id: 'insurance_radio_annual_recurring_iteration_benefit_1',
    defaultMessage: 'Cracked screen, water damage, any fault - we step in.',
  },
  annualRecurringIterationBenefit2: {
    id: 'insurance_radio_annual_recurring_iteration_benefit_2',
    defaultMessage: 'Unlimited repairs at no extra cost',
  },
  annualRecurringIterationBenefit3: {
    id: 'insurance_radio_annual_recurring_iteration_benefit_3',
    defaultMessage: 'Fast 3-day mail-in repairs.',
  },
  annualRecurringIterationBenefit4: {
    id: 'insurance_radio_annual_recurring_iteration_benefit_4',
    defaultMessage: 'No questions asked. Decision in 24h.',
  },
  annualRecurringIterationBenefit5: {
    id: 'insurance_radio_annual_recurring_iteration_benefit_5',
    defaultMessage:
      'Automatic annual renewal, which can be cancelled at any time',
  },
  saveOnAnnuallyOffer: {
    id: 'insurance_radio_save_on_annually_offer',
    defaultMessage: 'Save 16%',
  },
}
